import { createAction, props } from '@ngrx/store';
import { UserMenuListResponseModel } from './userMenuList.model';

export const LoadUserMenuList = createAction(
  '[UserMenuList] Load User Menu List',
  props<{ menu: UserMenuListResponseModel[] }>()
);
